import React from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

const KanbanBoard = ({ cases, onStatusChange, onCaseSelect }) => {
  const columns = {
    "Processing": { name: "Processing", items: [] },
    "Underwriting": { name: "Underwriting", items: [] },
    "Action Required": { name: "Action Required", items: [] },
    "Approved": { name: "Approved", items: [] },
    "Cleared to Close": { name: "Cleared to Close", items: [] },
    "Closing": { name: "Closing", items: [] },
    "Funded": { name: "Funded", items: [] },
    "Fall out": { name: "Fall out", items: [] },
  };

  cases.forEach(c => {
    if (columns[c.status]) {
      columns[c.status].items.push(c);
    }
  });

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination, draggableId } = result;

    if (source.droppableId !== destination.droppableId) {
      onStatusChange(draggableId, destination.droppableId);
    }
  };

  return (
    <div className="flex flex-nowrap gap-3 p-3">
      <DragDropContext onDragEnd={onDragEnd}>
        {Object.entries(columns).map(([columnId, column], index) => {
          return (
            <Droppable droppableId={columnId} key={columnId}>
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className={`dark:bg-slate-800/50 bg-gray-100 p-4 rounded-lg flex flex-col transition-colors flex-1 min-w-[280px] ${snapshot.isDraggingOver ? 'dark:bg-slate-700/50 bg-blue-50 dark:shadow-lg dark:shadow-sky-500/30' : ''}`}
                >
                  <h3 className="dark:text-white text-gray-900 font-semibold mb-3 text-sm uppercase tracking-wide">{column.name}</h3>
                  <div className="flex-1 overflow-y-auto space-y-2">
                    {column.items.map((item, index) => (
                      <Draggable key={item.id} draggableId={String(item.id)} index={index}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            onClick={() => onCaseSelect(item)}
                            className={`dark:bg-slate-900 bg-white p-3 rounded-lg border transition-all ${snapshot.isDragging ? 'dark:ring-2 dark:ring-sky-500 ring-2 ring-blue-500 dark:shadow-xl shadow-lg dark:border-sky-500 border-blue-500 cursor-grabbing' : 'dark:border-slate-800 border-gray-200 hover:border-gray-300 dark:hover:border-slate-700 hover:shadow cursor-grab'}`}
                          >
                            <p className="font-medium dark:text-white text-gray-900 text-sm">{item.name}</p>
                            <p className="text-xs dark:text-slate-400 text-gray-600 mt-1">{item.loanType}</p>
                            <p className="text-xs dark:text-slate-500 text-gray-500 mt-1">Case #: {item.caseNumber}</p>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                </div>
              )}
            </Droppable>
          );
        })}
      </DragDropContext>
    </div>
  );
};

export default KanbanBoard;